import { cn } from '@/lib/cn';
import { type CmsSize } from '@/services/cms-sdk/schemas/models/CmsSize';

export const cmsSize = {
    asBorderRadius: (size?: CmsSize) =>
        cn({
            'rounded-xs': size === 'xs',
            'rounded-sm': size === 'sm',
            'rounded-md': size === 'md',
            'rounded-lg': size === 'lg',
            'rounded-xl': size === 'xl',
            'rounded-2xl': size === '2xl',
            'rounded-3xl': size === '3xl',
            'rounded-4xl': size === '4xl',
        }),
    asGap: (size?: CmsSize) =>
        cn({
            'gap-8 xl:gap-1': size === 'xs',
            'gap-8 xl:gap-2': size === 'sm',
            'gap-8 xl:gap-4': size === 'md',
            'gap-8 xl:gap-6': size === 'lg',
            'gap-8 xl:gap-8': size === 'xl',
            'gap-8 xl:gap-12': size === '2xl',
            'gap-8 xl:gap-16': size === '3xl',
            'gap-8 xl:gap-24': size === '4xl',
        }),
};
